import requestManager from "@/components/platformApi/requestManager";

import appHelper from "@/util/appHelper";
import enumFactory from "@util/enumFactory";

export default {

    /**
     * @param   {String}    module
     * @param   {Function}  callback    first param is response data
     */
    getByModule(module, callback) {
        requestManager.request({
            url : 'portal/dict/getByModule',
            data : {
                module : module
            }
        }, (error, result) => {
            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            callback(result.data);
        })
    },

    getEnumByModule(module, callback) {
        this.getByModule(module, (data) => {
            // default:true
            // name:"公账"
            // sort:4
            // value:"4"
            let enumObj = {};
            for (let i=0; i<data.length; i++)
            {
                enumObj[data[i].name] = {
                    title : data[i].name,
                    code : data[i].value
                }
            }
            callback(enumFactory.createEnum(enumObj));
        })
    },


};
